const services = [
  {
    title: 'ヘッドスパ・\nドライヘッドマッサージ',
    titleEn: 'Head Spa',
    description: '頭皮を丁寧にケアし、深い精神的疲労を解消。目の疲れ・頭痛・不眠でお悩みの方に特におすすめです。',
    price: '¥7,700〜',
    duration: '60分〜',
    img: 'https://public.readdy.ai/ai/img_res/834fdf8119a7f398c184b45a4d38d185.jpg',
  },
  {
    title: 'フェイシャル・\n小顔矯正',
    titleEn: 'Facial Esthetics',
    description: 'お肌の健康と小顔効果を同時に叶える施術。肌の状態に合わせてカスタマイズした贅沢なフェイシャルケアです。',
    price: '¥8,800〜',
    duration: '60分〜',
    img: 'https://readdy.ai/api/search-image?query=luxury%20facial%20esthetics%20treatment%20close%20up%2C%20spa%20therapist%20performing%20gentle%20facial%20massage%20on%20client%2C%20warm%20lighting%2C%20white%20spa%20setting%2C%20botanical%20skincare%20products%2C%20relaxing%20Japanese%20wellness%20spa%20aesthetic&width=600&height=750&seq=svc002&orientation=portrait',
  },
  {
    title: 'よもぎ蒸し',
    titleEn: 'Mugwort Steam',
    description: '天然のよもぎを使った温活施術。身体の内側から温め、デトックス効果で代謝アップ・冷え性改善をサポートします。',
    price: '¥5,500〜',
    duration: '30分〜',
    img: 'https://readdy.ai/api/search-image?query=traditional%20Korean%20Japanese%20mugwort%20yomogi%20steam%20treatment%20spa%2C%20herbal%20steam%20rising%2C%20wooden%20spa%20chair%2C%20warm%20green%20herbs%2C%20soft%20ambient%20lighting%2C%20relaxing%20wellness%20ritual%2C%20natural%20botanical%20steam%20therapy&width=600&height=750&seq=svc003&orientation=portrait',
  },
  {
    title: 'リンパマッサージ',
    titleEn: 'Lymphatic Massage',
    description: 'むくみや老廃物をしっかり流すリンパドレナージュ。全身の巡りを整え、スッキリとした軽い身体へ導きます。',
    price: '¥8,800〜',
    duration: '60分〜',
    img: 'https://readdy.ai/api/search-image?query=gentle%20lymphatic%20massage%20therapy%20in%20serene%20spa%2C%20therapist%20hands%20working%20on%20client%20body%20with%20natural%20oil%2C%20soft%20cream%20linen%2C%20botanical%20oils%2C%20warm%20spa%20lighting%2C%20luxury%20Japanese%20wellness%20center%2C%20holistic%20body%20treatment&width=600&height=750&seq=svc004&orientation=portrait',
  },
];

export default function Services() {
  return (
    <section id="services" className="py-28 px-8 bg-white">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-4">
          <div>
            <p
              className="text-[#6b7c5c] text-xs tracking-[0.35em] mb-3"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              Treatment Menu
            </p>
            <h2
              className="text-stone-800 text-4xl md:text-5xl font-light"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              施術メニュー
            </h2>
          </div>
          <p
            className="text-stone-400 text-sm tracking-wide max-w-xs leading-relaxed"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            お客様のお悩みに合わせた<br />最適な施術をご提案いたします
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
          {services.map((svc) => (
            <div key={svc.titleEn} className="group relative rounded-2xl overflow-hidden cursor-pointer" style={{ aspectRatio: '3/4' }}>
              <img
                src={svc.img}
                alt={svc.titleEn}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />

              {/* Price badge */}
              <div className="absolute top-4 right-4 bg-white/20 backdrop-blur-sm rounded-full px-3 py-1">
                <span
                  className="text-white text-xs font-light"
                  style={{ fontFamily: "'Cormorant Garamond', serif" }}
                >
                  {svc.price}
                </span>
              </div>

              {/* Content */}
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <p
                  className="text-white/60 text-xs tracking-widest mb-1"
                  style={{ fontFamily: "'Cormorant Garamond', serif" }}
                >
                  {svc.titleEn}
                </p>
                <h3
                  className="text-white text-base font-light leading-snug mb-2 whitespace-pre-line"
                  style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                >
                  {svc.title}
                </h3>
                <p
                  className="text-white/70 text-xs leading-relaxed opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                  style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                >
                  {svc.description}
                </p>
                <div
                  className="mt-3 flex items-center gap-1 text-white/60 text-xs"
                  style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                >
                  <i className="ri-time-line text-xs" />
                  {svc.duration}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
